export const AUTH_API = process.env.REACT_APP_BASE_URL;
export const API_URL = AUTH_API +"/"+ sessionStorage.getItem('ext_url');
export const PUBLIC_API = AUTH_API+"/public";
export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_KEY;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const AUTHORITY = process.env.REACT_APP_AUTHORITY;
export const KNOW_AUTHORITIES = process.env.REACT_APP_KNOW_AUTHORITIES.split(",");

export const config = {
    navUrls: {
        massGov: "https://www.mass.gov/",
        massGovSnap: "https://mass.gov/snap",
        dtaConnect: "https://dtaconnect.eohhs.mass.gov/",
        snapNetwork: "https://www.snappathtowork.org/",
        dtaHip: "https://www.mass.gov/hip",
        mahealthyfoodsinasnap: "https://masnaped.org/",
        dtaListensUrl: "https://www.twitter.com/DTA_Listens",
        sitePoliciesUrl: "https://www.mass.gov/lists/eohhs-site-policies",
        accessibilityUrl: "https://www.mass.gov/eohhs/utility/eohhs-accessibility-policy.html",
        healthAndHumanService: "https://www.mass.gov/orgs/executive-office-of-health-and-human-services",
        userPanel:"https://www.mass.gov/user-panel?utm_source=survey",
        contactUs:"https://www.mass.gov/guides/how-to-contact-dta"
    }
};

export const appHomeUrl = process.env.REACT_APP_APPHOMEURL;

export const msalConfig = {
    auth: {
        clientId: CLIENT_ID,
        authority: AUTHORITY,
        knownAuthorities: KNOW_AUTHORITIES,
        redirectUri: appHomeUrl,
        postLogoutRedirectUri: appHomeUrl,
        // response_type: "id_token",
        // prompt: "login",
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ['openid'],
    extraQueryParameters: {},
    authority: AUTHORITY,
};


export const postLogoutRedirectUri = {
    redirectUri: `${appHomeUrl}/dtahip`
}

export const origin = "*"